import { render, staticRenderFns } from "./VMenu.vue?vue&type=template&id=0e2e07d2&scoped=true&"
import script from "./VMenu.vue?vue&type=script&lang=js&"
export * from "./VMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e07d2",
  null
  
)

export default component.exports